// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"13863ee8","505":"13863ee8"}[chunkId] + ".chunk.css";
};